import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import React from "react";
import { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ImageComponent from "../OrderCard/ImageComponent";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& h2": {
    background: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "500",
  },
}));

const DetailsDiv = styled(Box)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const ViewOrderList = (props) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });

  useEffect(() => {
    props.sendViewDetails(dialogDetails);
  }, [dialogDetails]);

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  return (
    <StyledDialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        View Orders
        <IconButton onClick={handleClose}>
          <Close style={{ color: "#fff" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          display={"grid"}
          gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
          alignItems={"center"}
          justifyContent={"center"}
          gap="10px"
          mb={1}
        >
          <div>
            <h4>Image</h4>
          </div>
          <div>
            <h4>Item</h4>
          </div>
          <div>
            <h4>Quantity</h4>
          </div>
          <Box textAlign={"right"}>
            <h4>Price</h4>
          </Box>
        </Box>
        <DetailsDiv>
          {props.viewDetails?.sales_details.map((sales, index) => {
            return (
              <Box
                display={"grid"}
                gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
                alignItems={"center"}
                gap="10px"
                key={sales.id}
                mb={1}
              >
                <div>
                  <Suspense>
                    <ImageComponent
                      imageUrl={sales.ax_relation.imageUrl}
                      alt={`sales-${sales.id}`}
                    />
                  </Suspense>
                </div>
                <div>
                  <p>{sales?.ax_relation?.ItemName}</p>
                  <div style={{ lineHeight: "1.0" }}>
                    <small>Colour: {sales?.ax_relation?.ColourName}</small>
                    <br />
                    <small>Size: {sales?.ax_relation?.SizeID}</small>
                  </div>
                </div>
                <Box textAlign={"center"}>
                  <p>{parseInt(sales?.amount)}</p>
                </Box>
                <Box textAlign={"right"}>${sales?.ax_relation?.RetailSalesPrice}</Box>
              </Box>
            );
          })}
        </DetailsDiv>
      </DialogContent>
    </StyledDialog>
  );
};

export default ViewOrderList;
